//  import React from 'react'
// import Header from '../components/Header'
// import Footer from '../components/Footer'
// const img1 = "/img/1.webp";
// const img2 = "/img/2.webp";
 
//  export default function Sp() {
//    return (
//      <div>
//      <Header/>
//      <Footer/>
       
//      </div>
//    )
//  }
 



import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'

const img1 = "/img/1.webp";
const img2 = "/img/2.webp";

export default function Sp() {
  return (
    <div >
      <Header />
    <div className="bg-gray-50 mt-[8rem] min-h-screen flex flex-col">
      {/* Image Section */}
      <section className="flex flex-col md:flex-row justify-center items-center gap-6 py-12 px-4">
        <div className=" overflow-hidden rounded-2xl shadow-lg transform transition duration-300 hover:scale-105 hover:shadow-2xl">
          <img src={img1} alt="Beautiful 1" className="w-full h-auto object-cover" />
        </div>
        <div className=" overflow-hidden rounded-2xl shadow-lg transform transition duration-300 hover:scale-105 hover:shadow-2xl">
          <img src={img2} alt="Beautiful 2" className="w-full h-auto object-cover" />
        </div>
      </section>
      </div>

      <Footer />
    </div>
  )
}
